function NXImage({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 12H12.5C13.0523 12 13.5 11.5523 13.5 11V3C13.5 2.44771 13.0523 2 12.5 2H1.5C0.947715 2 0.5 2.44771 0.5 3V11C0.5 11.5523 0.947715 12 1.5 12Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.50191 6.21206C10.1896 6.21206 10.7471 5.65457 10.7471 4.96687C10.7471 4.27917 10.1896 3.72168 9.50191 3.72168C8.81421 3.72168 8.25671 4.27917 8.25671 4.96687C8.25671 5.65457 8.81421 6.21206 9.50191 6.21206Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.08269 12.0001C8.77218 10.3462 7.88415 8.85646 6.57706 7.79666C5.26997 6.73685 3.62885 6.17593 1.94652 6.21397C1.46114 6.21268 0.976755 6.25789 0.5 6.34898"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 8.94077C12.7123 8.67478 11.8865 8.53934 11.0551 8.53981C10.0028 8.53753 8.96111 8.75052 7.99414 9.1657"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default NXImage;
